import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';

const schema = z.object({
  facebook_page_name: z.string().min(1, 'Name is required'),
  facebook_page_id: z.string().min(1, 'Facebook Page ID is required'),
  instagram_page_id: z.string(),
});

export default {
  schema,
  resolver: zodResolver(schema),
} as {
  schema: typeof schema;
  resolver: Resolver<z.infer<typeof schema>>;
};
